import AffirmationTranslationsResponse from '../../../../../Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationTranslationsResponse';

export default class AffirmationGetListResponse  {
	Id: number = 0;
	IsPaid: boolean = false;
	Created: Date = null;
	UseBackgroundMusic: boolean = false;
	CoverUrl?: string = '';
	BackUrl?: string = '';
	IconUrl?: string = '';
	AnimationId?: string = '';
	AnimationUrl?: string = '';
	SortIndex: number = 0;
	Translations: Array<AffirmationTranslationsResponse> = null;
	constructor(obj?: Partial<AffirmationGetListResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
